"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Unpin = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var Unpin = function Unpin() {
  return react_1.default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M23.605 6.003L18.02.39a1.327 1.327 0 00-.931-.388 1.33 1.33 0 00-1.33.882l-.612 1.925a2.671 2.671 0 01-1.038 1.336L9.851 6.992a3.977 3.977 0 01-2.248.695H5.623a1.326 1.326 0 00-.945.334l-.545.561a1.34 1.34 0 000 1.885l9.404 9.449a1.326 1.326 0 001.876 0l.558-.548a1.34 1.34 0 00.386-.95v-1.95c0-.806.24-1.593.692-2.26l2.833-4.276c.32-.483.786-.849 1.33-1.042l1.916-.682a1.34 1.34 0 00.479-2.205zM18.06 7.847l-5.122 7.738-4.456-4.477 7.702-5.145 1.81-1.818 1.875 1.885-1.81 1.817zm-17 12.79a4.01 4.01 0 01.891-1.336l3.884-3.903 2.687 2.807-3.87 3.889c-.38.386-.832.69-1.33.895l-2.408.963a.663.663 0 01-.719-.147.67.67 0 01-.146-.722l1.011-2.446z",
    clipRule: "evenodd"
  });
};

exports.Unpin = Unpin;